// icons
import email from '@iconify/icons-carbon/email';
import phone from '@iconify/icons-carbon/phone';
// @mui
import { Button, Card, Link, Stack, Typography } from '@mui/material';
import NextLink from 'next/link';
import { ServiceProps } from 'src/@types/service';
// components
import { Iconify, TextIconLabel } from '../../components';
import Image from '../../components/NextSanityImage';

// ----------------------------------------------------------------------

type Props = {
  service: ServiceProps;
};

export default function ServiceInfo({ service }: Props) {
  const { contact, slug } = service;

  return (
    <Card sx={{ p: 3, borderRadius: 2 }}>
      <Stack spacing={3}>
        {contact.profile && (
          <Image alt={contact.name + " kontaktperson"} src={contact.profile} ratio="1/1" sx={{ borderRadius: 2 }} />
        )}

        <Stack spacing={2}>
          <Typography variant="overline" sx={{ color: 'text.secondary', mb: -1 }}>
            Kontaktperson
          </Typography>
          <Typography variant="subtitle1">{contact.name}</Typography>
          <TextIconLabel
            icon={<Iconify icon={phone} sx={{ width: 20, height: 20, mr: 1 }} />}
            value={<Link color="info" href={"tel:" + contact.phone}>{contact.phone}</Link>}
          />
          <TextIconLabel
            icon={<Iconify icon={email} sx={{ width: 20, height: 20, mr: 1 }} />}
            value={<Link color="info" href={"mailto:" + contact.email}>{contact.email}</Link>}
          />
        </Stack>

        <NextLink href={`/form/?service=${slug.current}`} passHref>
          <Button size="large" variant="contained">
            Benytt kontaktskjema
          </Button>
        </NextLink>
      </Stack>
    </Card>
  );
}
